import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import { AccordionDetails, AccordionSummary, Tooltip } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Translate } from "../../../../../shared/LanguageService";

export type CostCheck = {
    photographer: string;
    product: string;
    orderUrl: string;
    amount: number;
};

type CostCheckProps = {
    costs: CostCheck[];
};

export function CostCheck({ costs }: CostCheckProps) {
    return (
        <Box sx={{ padding: '20px 0' }}>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <Typography component="span">
                        {Translate('economy/photographer-invoice-collection/pending/top-ten')}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Box component="table" sx={{ width: '100%' }}>
                        <thead>
                            <tr>
                                <th>{Translate('role/photographer')}</th>
                                <Box component="th" sx={{ textAlign: 'right' }}>
                                    {Translate('invoice/payments/import/feedback/list/amount')}
                                </Box>
                            </tr>
                        </thead>
                        <Box
                            component="tbody"
                            sx={{
                                '& tr a td:nth-of-type(2)': {
                                    textAlign: 'right'
                                },
                                '& tr a': {
                                    display: 'contents',
                                    textDecoration: 'none',
                                    color: 'inherit'
                                },
                                '& tr:nth-of-type(odd)': { backgroundColor: '#f5f5f5' },
                                '& tr:hover': {
                                    backgroundColor: '#e0e0e0'
                                }
                            }}
                        >
                            {costs.map((cost, index) => (
                                <Tooltip placement="left-start" key={index} title={cost.product}>
                                    <Box component="tr" sx={{ cursor: 'pointer' }}>
                                        <Box
                                            component="a"
                                            href={cost.orderUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <td>{cost.photographer}</td>
                                            <td>{cost.amount}</td>
                                        </Box>
                                    </Box>
                                </Tooltip>
                            ))}
                        </Box>
                    </Box>
                </AccordionDetails>
            </Accordion>
        </Box>
    );
}
